"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagsDemo = void 0;
var lodash_1 = __importDefault(require("lodash"));
var React = __importStar(require("react"));
var __1 = require("..");
var Tags_1 = require("./Tags");
var TagsDemo = /** @class */ (function (_super) {
    __extends(TagsDemo, _super);
    function TagsDemo(props) {
        var _this = _super.call(this, props) || this;
        _this.handleAddTag = function (value) {
            var tags = _this.state.tags;
            var items = __spreadArray(__spreadArray([], _this.state.items, true), [value], false);
            var selectedTags = __spreadArray(__spreadArray([], tags, true), [value.name], false);
            _this.setState({ items: items, tags: selectedTags });
        };
        _this.handleUpdateTags = function (values, items) {
            _this.setState({ tags: values });
        };
        _this.handleRemoveTags = function (values) {
            var tags = lodash_1.default.map(values, function (c) { return c.value; });
            _this.setState({ tags: tags });
        };
        _this.state = {
            tags: [],
            items: [
                { name: '1', displayText: 'First' },
                { name: '2', displayText: 'Second' },
                { name: '3', displayText: 'Third' },
                { name: '4', displayText: 'Fourth' },
                { name: '5', displayText: 'Fifth' },
                { name: '6', displayText: 'Sixth' },
            ],
        };
        return _this;
    }
    TagsDemo.prototype.render = function () {
        var _a = this.state, items = _a.items, tags = _a.tags;
        return (React.createElement("div", null,
            React.createElement(Tags_1.Tags, { items: items, selectSize: 'lg', displayText: 'Tags', showSearch: true, showApplyButton: true, showCount: true, selectedValues: tags, onAddNew: this.handleAddTag, onApply: this.handleUpdateTags }),
            tags && tags.length > 0 && (React.createElement(__1.Crumblist, { enableDismiss: true, data: tags.map(function (tag) {
                    var item = lodash_1.default.find(items, function (i) { return i.name === tag; });
                    return item ? { displayText: item.displayText, value: item.name } : { displayText: tag, value: tag };
                }), update: this.handleRemoveTags }))));
    };
    return TagsDemo;
}(React.Component));
exports.TagsDemo = TagsDemo;
